export default __webpack_public_path__ + "static/abbeyRoad-45256ccc5f88eabd82e36cab69e49325.svg";